import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  async closeModalOnNonModalTurboRender(e) {
    let text = await e.detail.fetchResponse.responseText

    if (
      !text.includes(
        '<turbo-stream action="update" target="dynamic-modal-content">'
      )
    ) {
      if (typeof HSOverlay == "function" && document.querySelector("#modal")) {
        new HSOverlay(document.querySelector("#modal")).close()
      }
    }
  }
}
